import { createAsyncThunk } from '@reduxjs/toolkit'
import * as api from '@services/api'

export const fetchCreatorTypes = createAsyncThunk(
  'customer/fetchCreatorTypes',
  async () => {
    const response = await api.getCreatorTypes()
    return response
  }
)

export const createCreatorType = createAsyncThunk(
  'customer/createCreatorType',
  async (data: any) => {
    const response = await api.createCreatorType(data)
    return response
  }
)

export const updateCreatorType = createAsyncThunk(
  'customer/updateCreatorType',
  async (data: any) => {
    const response = await api.updateCreatorType(data)
    return response
  }
)

export const downloadCustomers = createAsyncThunk(
  'customer/downloadCustomers',
  async (params: any) => {
    const response = await api.downloadCustomers(params)
    return response
  }
)

export const uploadCustomerCreatorTypes = createAsyncThunk(
  'customer/uploadCustomerCreatorTypes',
  async (data: any) => {
    const response = await api.uploadCustomerCreatorTypes(data)
    return response
  }
)

export const fetchCustomerList = createAsyncThunk(
  'customer/fetchCustomerList',
  async (params: any) => {
    const response = await api.fetchCustomerList(params)
    return response
  }
)

export const updateCustomerInfo = createAsyncThunk(
  'customer/updateCustomerInfo',
  async (data: any) => {
    const response = await api.updateCustomer(data)
    return response
  }
)

export const fetchUserPoints = createAsyncThunk(
  'customer/fetchUserPoints',
  async (searchData: object) => {
    const response = await api.fetchUserPoints(searchData)
    return response
  }
)

export const addPoints = createAsyncThunk(
  'customer/addPoints',
  async (data: any, { getState }) => {
    const state: any = getState()
    data.adminUserId = state.auth.user.userId
    const response = await api.addPoints(data)
    return response
  }
)

export const fetchReport = createAsyncThunk(
  'customer/fetchReport',
  async (params: any) => {
    const response = await api.fetchUserReports(params)
    return response
  }
)

export const confirmReport = createAsyncThunk(
  'customer/confirmReport',
  async (data: any) => {
    const response = await api.confirmReport(data)
    return response
  }
)

export const setCreatorType = createAsyncThunk(
  'customer/setCreatorType',
  async (data: any) => {
    const response = await api.setCustomerCreatorType(data)
    return response
  }
)

export const fetchCreatorTypeHistory = createAsyncThunk(
  'customer/getCreatorTypeHistory',
  async (params: any) => {
    const response = await api.getCustomerCreatorTypeHistory(params)
    return response
  }
)

export const fetchDeleteCreatorType = createAsyncThunk(
  'customer/fetchDeleteCreatorType',
  async (params: any) => {
    const response = await api.deleteCreatorType(params)
    return response
  }
)
